import React from "react";
import ReactDOM from "react-dom";
import { Switch, Route } from "react-router-dom";
import Footer from "./layout/Footer";
import FooterBottom from "./layout/FooterBottom";
import MobileNavi from "./layout/MobileNavi";
import Landingpage from "./pages/Landingpage";
import AppStore from "./pages/appStore";
import AboutUs from "./pages/about";
import Sale from "./pages/sale";
import ContactUs from "./pages/contact";
import Connect from "./pages/connect";
import BuySim from "./pages/buysim";
import BuySimCart from "./pages/buysimCart";
import GetSim from "./pages/getsim";
import SimCart from "./pages/simCart";
import GetWifiUS from "./pages/getwifius";
import GetWifiGlobal from "./pages/getwifiglobal";
import Buy from "./pages/buy";
import Rent from "./pages/rent";
import Login from "./pages/login";
import SignUp from "./pages/signup";
import Checkout from "./pages/checkout";
import Dashboard from "./pages/dashboard";
import ForgotPassword from "./pages/forgotPassword";
import FlashMessagesList from "./flash/FlashMessagesList";
import requireAuth from "./modules/utils/requireAuth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import faq from "./pages/faq";
import privacyPolicy from "./pages/privacyPolicy";
import resetPassword from "./pages/resetPassword";
import pricing from "./pages/pricing";
import newpricing from "./pages/newpricing";
import TermsAndCondition from "./pages/termAndConditions";
import RechargeSim from "./pages/rechargeSim";
import ActiveSim from "./pages/ActiveSim";
import ActiveDevice from "./pages/ActiveDevice";
import PurchaseDevice from "./pages/purchaseDevice";
import RechargeDevice from "./pages/rechargeDevice";
import PurchaseESim from "./pages/purchaseESim";
import ReactGA from 'react-ga4';
import Validator from "validator";
import {isEmailDomain} from "./modules/utils";
import isEmpty from "lodash/isEmpty";
import CacheBuster from './CacheBuster';
/*import dotenv from "dotenv";

dotenv.config();*/

const uuidv4 = require("uuid/v4");

/* Google Analytics */
var GA_MEASUREMENT_ID = "";
//Production: UA-140805823-1
//DEV: UA-140805823-3
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === "production") {
  //GA_MEASUREMENT_ID = "UA-140805823-1";
  GA_MEASUREMENT_ID = "G-W6RXM46S9S";
  console.log("===PRODUCTION===");
} else {
  //GA_MEASUREMENT_ID = "UA-140805823-3";
  GA_MEASUREMENT_ID = "G-8DTTMESCNH";
  console.log("===DEVELOPMENT===");
}

ReactGA.initialize(GA_MEASUREMENT_ID);

const logPageView = () => {
  /*ReactGA.set({
    page: getPathName(window.location.pathname),
    title: getPageTitle(window.location.pathname)
  });
  ReactGA.pageview(getPathName(window.location.pathname));*/
  ReactGA.send({
    hitType: "pageview",
    page: getPathName(window.location.pathname),
    title: getPageTitle(window.location.pathname)
  });
  return null;
};
/* Google Analytics */

String.prototype.startsWith = function(str) {
  return (this.indexOf(str) === 0);
};

function getPathName(pathname) {
  let pathName = pathname;

  if(pathname.startsWith("/reset-password")) {
    pathName = "/reset-password";
  }

  return pathName;
}

function getPageTitle(pathname) {
  //let pageTitle = "MightyWifi > ";
  let pageTitle = "";

  switch (pathname) {
    case "/":
      pageTitle += "Main";
      break;
    case "/app-store" :
      pageTitle += "App Store";
      break;
    case "/checkout" :
      pageTitle += "Check Out";
      break;
    case "/dashboard" :
      pageTitle += "My Account";
      break;
    case "/dashboard/orderhistory" :
      pageTitle += "My Account > Order History";
      break;
    case "/dashboard/autorenewal" :
      pageTitle += "My Account > Auto Renewal";
      break;
    case "/dashboard/update/password" :
      pageTitle += "My Account > Update Password";
      break;
    case "/signup" :
      pageTitle += "Sign Up";
      break;
    case "/login" :
      pageTitle += "Sign In";
      break;
    case "/about-us" :
      pageTitle += "About Us";
      break;
    case "/sale" :
      pageTitle += "Sale";
      break;
    case "/contact-us" :
      pageTitle += "Contact Us";
      break;
    case "/connect" :
      pageTitle += "Connect";
      break;
    case "/forgot-password" :
      pageTitle += "Forgot Password";
      break;
    case "/faq" :
      pageTitle += "FAQ";
      break;
    case "/pricing" :
      pageTitle += "Pricing";
      break;
    case "/newpricing" :
      pageTitle += "Current US Price";
      break;
    case "/termsofuse" :
      pageTitle += "Terms and Conditions";
      break;
    case "/privacy-policy" :
      pageTitle += "Privacy Policy";
      break;
      /*
      case "/get-wifi-global" :
          pageTitle += "Get Wifi Global";
          break;
      */
    case "/get-wifi/global" :
      pageTitle += "Get Wifi Global";
      break;
    case "/get-wifi" :
      pageTitle += "Get Wifi US";
      break;
    case "/buy-sim" :
      pageTitle += "Buy SIM";
      break;
      /*
      case "/buy-sim/cart" :
        pageTitle += "Buy SIM Cart";
        break;
      */
    case "/get-sim" :
      pageTitle += "Get SIM";
      break;
      /*
      case "/get-sim/cart" :
          pageTitle += "Get SIM Cart";
          break;
      */
    case "/activate/sim" :
      pageTitle += "Activate SIM";
      break;
    case "/activate" :
      pageTitle += "Activate Device";
      break;
    case "/rent" :
      pageTitle += "Rent Device";
      break;
      /*
      case "/buy" :
          pageTitle += "Buy";
          break;
      */
    case "/buy/device" :
      pageTitle += "Buy Device";
      break;
      /*case "/buy/device/119" :
        pageTitle += "Buy Device (FREE 3GB Promotion)";
        break;
      case "/buy/device/159" :
        pageTitle += "Buy Device (FREE 50GB Promotion)";
        break;*/
    case "/recharge" :
      pageTitle += "Recharge SIM";
      break;
    case "/recharge/device" :
      pageTitle += "Recharge Device";
      break;
    case "/buy/esim" :
      pageTitle += "Buy eSIM";
      break;
  }

  if(pathname.startsWith("/reset-password")) {
    pageTitle += "Reset Password";
  }

  return pageTitle;
}

class App extends React.Component {
  componentDidMount() {
    if (!localStorage.getItem("sessionId")) {
      localStorage.setItem("sessionId", uuidv4());
    }
  }

  componentDidUpdate = () => {
    ReactDOM.findDOMNode(this).scrollIntoView();
  };
  render() {
    return (
        <CacheBuster>
          {({ loading, isLatestVersion, refreshCacheAndReload }) => {
            if (loading) return null;
            if (!loading && !isLatestVersion) {
              refreshCacheAndReload();
            }
            return (
                <div>
                  <ToastContainer />
                  <FlashMessagesList />
                  <Route path="/" component={logPageView} />
                  <Switch>
                    {/*<Route path="/" component={Landingpage} />*/}
                    <Route exact path="/" render={(props) => <Landingpage {...props} showModal={!loading && isLatestVersion} />} />
                    <Route path="/app-store" component={AppStore} />
                    <Route path="/checkout" component={requireAuth(Checkout)} />
                    <Route path="/dashboard" component={requireAuth(Dashboard)} />
                    <Route path="/signup" component={SignUp} />
                    <Route path="/login" component={Login} />
                    <Route path="/about-us" component={AboutUs} />
                    <Route path="/sale" component={Sale} />
                    <Route path="/contact-us" component={ContactUs} />
                    <Route path="/connect" component={Connect} />
                    <Route path="/forgot-password" component={ForgotPassword} />
                    <Route path="/faq" component={faq} />
                    {/*<Route path="/pricing" component={pricing} />*/}
                    {/*<Route path="/newpricing" component={newpricing} />*/}
                    <Route path="/termsofuse" component={TermsAndCondition} />
                    <Route path="/privacy-policy" component={privacyPolicy} />
                    <Route path="/reset-password/:id" component={resetPassword} />
                    {/*<Route path="/get-wifi-global" component={GetWifiGlobal} />*/}
                    <Route path="/get-wifi/:type" component={GetWifiUS} />
                    <Route path="/get-wifi" component={GetWifiUS} />
                    <Route path="/rent" component={Rent} />
                    <Route exact path="/buy-sim" component={BuySim} />
                    <Route path="/buy-sim/cart" component={BuySimCart}/>
                    <Route exact path="/get-sim" component={GetSim} />
                    <Route path="/get-sim/cart" component={SimCart}/>
                    <Route path="/activate/sim" component={requireAuth(ActiveSim)}/>
                    <Route path="/activate" component={requireAuth(ActiveDevice)}/>
                    <Route exact path="/buy" component={Buy} />
                    <Route exact path="/buy/device" component={PurchaseDevice} />
                    {/*<Route exact path="/buy/device/:promotion" component={PurchaseDevice} />*/}
                    <Route exact path="/recharge" component={RechargeSim}/>
                    {/*<Route exact path="/recharge/device" component={RechargeDevice} />*/}
                    <Route exact path="/recharge/device" component={requireAuth(RechargeDevice)} />
                    {/*<Route exact path="/buy/esim" component={PurchaseESim} />*/}
                  </Switch>
                  <Footer />
                  <FooterBottom />
                  <MobileNavi />
                </div>
            );
          }}
        </CacheBuster>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js